import Container from "@@/elements/Container";
import Typography from "@@/elements/Typography";
import { ScreenSize, useIsBreakpointOrBelow } from "@@/hooks/device/use-breakpoint";
import EpiContent from "@@/integrations/optimizly/Content";
import Box from "@@/elements/Box";
import styles from "./index.module.scss";
import BranchInfoCard, { CardProps } from "./card";
import { CardColors } from "../Card/CardProps";

type BranchInfoCardsProps = {
  header?: string,
  color: CardColors,
  cards: CardProps[]
};

const BranchInfoCards = ({
  header, cards, color,
}: BranchInfoCardsProps) => {
  const isSmall = useIsBreakpointOrBelow(ScreenSize.SMALL);

  return (
    <Container>
      {header && (<Typography mb={[10, 12, 14]} textAlign="center" variant="heading1" asElement="h2">{header}</Typography>)}
      {cards.length === 1 && (
        <Box>
          {cards.map((card) => (
            <BranchInfoCard icon={card.icon} header={card.header} body={card.body} link={card.link} color={color} centered={!isSmall} />
          ))}

        </Box>
      )}
      {cards.length > 1 && (
      <EpiContent>
        <Box className={(cards.length === 2 || cards.length === 4) ? styles.grid : styles.cards_grid}>
          {cards.map((card) => (
            <Box component="span">
              <BranchInfoCard icon={card.icon} header={card.header} body={card.body} link={card.link} color={color} centered={false} />
            </Box>
          ))}
        </Box>
      </EpiContent>
      )}
    </Container>
  );
};

export default BranchInfoCards;
